<h2 mat-dialog-title class="dialog-title !text-xl !font-bold !mb-2">Edição em Massa</h2>

<mat-dialog-content class="dialog-content">

    <app-alert-card type="info" class="mb-3 d-block">
        Campos deixados em branco <strong>não serão alterados</strong>.
        A edição será aplicada a <strong>{{ qtdSelecionados }} parcela(s)</strong> selecionada(s).
    </app-alert-card>

    <div [formGroup]="model">

        <div class="section-subtitle">
            <mat-icon>corporate_fare</mat-icon>
            <span>Informações do documento</span>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                <app-select-pesquisavel [control]="idClienteControl" label="Cliente" [apiUrl]="urlCliente"
                    idField="id" nameField="descricao" [isOptional]="true">
                </app-select-pesquisavel>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Lançamento (Competência)</mat-label>
                    <input matInput [matDatepicker]="pickerCompetencia" formControlName="dataCompetencia"
                        placeholder="DD/MM/AAAA">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerCompetencia"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCompetencia></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Categoria</mat-label>
                    <mat-select formControlName="idCategoriaFinanceira">
                        <mat-option [value]="null">— Não alterar —</mat-option>
                        @for (cat of data.categoriasFinanceiras; track cat.idCategoriaFinanceira) {
                        <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Centro de Custo</mat-label>
                    <mat-select formControlName="idCentroCusto">
                        <mat-option [value]="null">— Não alterar —</mat-option>
                        @for (cc of data.centrosCusto; track cc.idCentroCusto) {
                        <mat-option [value]="cc.idCentroCusto">{{ cc.nome }}</mat-option>
                        }
                    </mat-select>
                    <mat-hint>Documentos com rateio configurado não podem ter o centro de custo alterado e serão
                        bloqueados.</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="section-subtitle mt-3">
            <mat-icon>receipt_long</mat-icon>
            <span>Informações da parcela</span>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descrição</mat-label>
                    <input matInput formControlName="descricao" placeholder="Deixe vazio para não alterar">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observação</mat-label>
                    <input matInput formControlName="observacaoHtml" placeholder="Deixe vazio para não alterar">
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Conta Financeira</mat-label>
                    <mat-select formControlName="idContaFinanceira">
                        <mat-option [value]="null">— Não alterar —</mat-option>
                        @for (cf of data.contasFinanceiras; track cf.idContaFinanceira) {
                        <mat-option [value]="cf.idContaFinanceira">{{ cf.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="section-subtitle mt-3">
            <mat-icon>attach_file</mat-icon>
            <span>Anexos da Parcela</span>
        </div>

        <div class="col-12">
            <div class="upload-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                <input type="file" #fileInput multiple (change)="onFileSelected($event)" style="display: none;">
                <div class="upload-dropzone" [class.drag-over]="isHovering" (click)="fileInput.click()">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
                    <p class="upload-hint">Limitado a 2mb por arquivo (Máximo 10MB Total)</p>
                </div>
            </div>
        </div>

        @if (anexos.length > 0) {
        <div class="col-12">
            <div class="file-list mt-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <p class="mb-0 font-weight-bold">Arquivos Selecionados:</p>
                    <button type="button" mat-button (click)="limparAnexos()">
                        <mat-icon>delete_sweep</mat-icon> Limpar Todos
                    </button>
                </div>
                @for (file of anexos; track $index; let i = $index) {
                <div class="file-item">
                    <div class="file-info">
                        <mat-icon class="file-icon">description</mat-icon>
                        <div class="file-details">
                            <span class="file-name">{{ file.nomeArquivo }}</span>
                            <span class="file-size">{{ formatBytes(file.tamanhoBytes) }}</span>
                        </div>
                    </div>
                    <button mat-icon-button type="button" (click)="removeAnexo(i)" matTooltip="Remover arquivo"
                        class="close-icon">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                }
            </div>
        </div>
        }

    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions mt-4">
    <button mat-flat-button class="btn-secondary mr-2" (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="isLoading">
        @if (isLoading) {
        <mat-spinner diameter="18" class="me-2"></mat-spinner>
        } @else {
        Salvar alterações
        }
    </button>
</mat-dialog-actions>